import { motion } from 'framer-motion';
import { useEffect } from 'react';

export default function PageWrapper({ children }) {
	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);

	return (
		<motion.div
			initial={{ opacity: 0, x: 100 }}
			animate={{ opacity: 1, x: 0 }}
			exit={{ opacity: 0, x: -100 }}
			transition={{ duration: 0.2, ease: 'easeInOut' }}
		>
			{children}
		</motion.div>
	);
}
